import { Instance, types } from 'mobx-state-tree';
import CallSessionState from './CallSessionState';

const InsightCallSessionState = CallSessionState.named('InsightCallSessionState').props({
  feedbackLinkRelative: '',
  rescheduleLinkRelative: '',
  hasUpcomingPayment: false,
  parentAttendedSession: false,
  batchStudentName: '',
  rescheduledSessionName: types.maybeNull(types.string),
  meritAdmissionLink: types.maybeNull(types.string),
  // "Coffee Connect", "Onboarding call" or "Office hour", from sq_api.
  callDisplayName: types.string,
});

export default InsightCallSessionState;
export interface IInsightCallSessionState extends Instance<typeof InsightCallSessionState> {}
